import {PERMISSION_NAMES} from "@/const/online-permissions";

export const defaultOnLineSidebarItems = [
  {
    key: "users",
    pathName: "users",
    icon: "group",
    text: "Users",
    activeRoutes: ["users-edit"],
    onlyAdmins: true,
  },
  {
    key: "translations",
    pathName: null,
    icon: "translate",
    text: "Translations",
    requiredPermissions: [`${PERMISSION_NAMES.TRANSLATIONS.key}.${PERMISSION_NAMES.TRANSLATIONS.key}`],
    subItems: [
      {
        key: "all-translations",
        pathName: "all-translations",
        icon: "list_alt",
        text: "All translations",
      },
      {
        key: "languages",
        pathName: "languages",
        icon: "language",
        text: "Languages",
      },
      {
        key: "sections",
        pathName: "sections",
        icon: "folder",
        text: "Sections",
      }
    ],
  },
  {
    key: "websites",
    pathName: "websites",
    icon: "public",
    text: "Websites",
    activeRoutes: ["websites-edit"],
    requiredPermissions: [
      `${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.WEBSITES_CONFIGURATION.key}`,
      `${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.SEO_RULES.key}`,
      `${PERMISSION_NAMES.WEB_SITES.key}.${PERMISSION_NAMES.TOOLTIPS.key}`,
    ]
  },
  {
    key: "companies",
    pathName: "companies",
    icon: "business",
    text: "Companies",
    activeRoutes: ["markets", "betshops"],
    onlyAdmins: true,
  },
  {
    key: "configurations",
    pathName: "configurations",
    icon: "tune",
    text: "Configurations",
    requiredPermissions: [
      `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.TOOLTIPS.key}`,
      `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.BIG_JACKPOT.key}`,
      `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.IMG_ARENA.key}`,
      `${PERMISSION_NAMES.CONFIGURATION.key}.${PERMISSION_NAMES.ICONS.key}`,
    ]
  },
  {
    key: "help",
    pathName: "on-line-help",
    icon: "help",
    text: "Help CMS",
    requiredPermissions: [
      `${PERMISSION_NAMES.HELP.key}.${PERMISSION_NAMES.HELP.key}`,
    ]
  },
  {
    key: "vip",
    pathName: "on-line-vip",
    icon: "workspace_premium",
    text: "VIP CMS",
    requiredPermissions: [
      `${PERMISSION_NAMES.VIP.key}.${PERMISSION_NAMES.VIP.key}`,
    ]
  },
  {
    key: "configurations-setup",
    pathName: null,
    icon: "build",
    text: "Configurations Setup",
    onlyDevelopers: true,
    subItems: [
      {
        key: "online-configuration-sections",
        pathName: "online-configuration-sections",
        icon: "view_agenda",
        text: "Sections",
      },
      {
        key: "online-configuration-types",
        pathName: "online-configuration-types",
        icon: "category",
        text: "Types",
      },
      {
        key: "online-configuration-settings",
        pathName: "online-configuration-settings",
        icon: "settings",
        text: "Configuration settings",
      },
    ],
  },
  {
    key: "terminal-payments",
    pathName: "terminal-payments",
    icon: "point_of_sale",
    text: "Terminal Payments",
    requiredPermissions: [
      `${PERMISSION_NAMES.TERMINAL_PAYMENTS.key}.${PERMISSION_NAMES.TERMINAL_PAYMENTS.key}`,
    ]
  },
  {
    key: "trending-configuration",
    pathName: "trending-configuration",
    icon: "trending_up",
    text: "Trending Configuration",
    requiredPermissions: [
      `${PERMISSION_NAMES.TERMINAL_PAYMENTS.key}.${PERMISSION_NAMES.TERMINAL_PAYMENTS.key}`,
    ]
  },
];
